import React, { useContext, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Sidebare from '../Sidbare/Sidebare';
import './editMagasin.css';
import profil from '../IMG/defaultProfil.png';
import AfficheProductsService from '../../../Services/Admin/AfficheProductsService';
import { ArticleInfo } from '../../../Modeles/ArticleModel';
import { CommercialInfo } from '../../../Modeles/Commercial';
import AfficheCommercialMagasinInAdmin from '../../../Services/Admin/AfficheCommercialMagainInAdmin';
import AfficheClientMagasinInAdmin from '../../../Services/Admin/AfficheClientMagasinInAdmin';
import { ClientInfo } from '../../../Modeles/Client';
import { Commande } from '../../../Modeles/Commande';
import AfficheCommandeByMagasin from '../../../Services/Admin/AfficheCommandeByMagasin';
import MagasinInfoService from '../../../Services/Magasin/MagasinInfo';
import { MagasinInfo } from '../../../Modeles/MagasinModel';
import { MagasinContext } from '../../../Context/MagasinContext';
import axios, { AxiosError } from 'axios';
import { NewSideBarAdmin } from '../../NewSideBarAdmin';

export interface ProductType {
  product: ArticleInfo[];
  messageErros: string;
}

export interface CommercialType {
  commercial: CommercialInfo[];
  messageErrosCommercial: string;
}

export interface ClientType {
  Client: ClientInfo[];
  messageErrosClient: string;
}

export interface CommandeType {
  Commande: Commande[];
  messageErrosCommande: string;
}

export interface MagasinType {
  Info: MagasinInfo[];
  messageErrosInfo: string;
}

export const EditeMagasinUpgraded: React.FC<ArticleInfo> = ({
  Magasin,
  Nom_prprietaire,
  email,
  password,
  adresse_de_siege,
  setMagasin,
  setNom_prprietaires,
  setemail,
  tele,
  settele,
  setpassword,
  setadresse_de_siège,
  handleSubmitUpdate,
  Message,
  setMessage,

}) => {

  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState<'info' | 'orders' | 'staff'>('info');
  const [isEditing, setIsEditing] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  // Order detail popup
  const [selectedCommande, setSelectedCommande] = useState<Commande | null>(null);

  const magasinContext = useContext(MagasinContext);
  const MagasinId = localStorage.getItem('MagasinId');
  const idmagasin = MagasinId || magasinContext.id?.id;
  const { id } = useParams();

  // State Management
  const [stateInfo, setInfo] = useState<MagasinType>({
    Info: [] as MagasinInfo[],
    messageErrosInfo: 'Aucune info',
  });

  const [stateCommande, setstateCommande] = useState<CommandeType>({
    Commande: [] as Commande[],
    messageErrosCommande: 'Aucune commande',
  });

  const [stateClient, setstateClient] = useState<ClientType>({
    Client: [] as ClientInfo[],
    messageErrosClient: 'Aucun client',
  });

  const [stateCommercial, setStateCommercial] = useState<CommercialType>({
    commercial: [] as CommercialInfo[],
    messageErrosCommercial: 'Aucun commercial',
  });

  const [stateProduct, setStateProduct] = useState<any>({
    product: [] as ArticleInfo[],
    messageErros: 'Aucun produit',
  });

  // Fetch Magasin Info
  useEffect(() => {
    setLoading(true);
    MagasinInfoService(id)
      .getMagasinInfo()
      .then((res) => setInfo({ Info: res.data, messageErrosInfo: '' }))
      .catch((err) => setInfo({ Info: [], messageErrosInfo: err.message || 'Erreur info magasin' }))
      .finally(() => setLoading(false));
  }, [id]);

  // Fetch Commands
  useEffect(() => {
    AfficheCommandeByMagasin(id)
      .GetCommande()
      .then((res) => {
        setstateCommande((prev) => ({
          ...prev,
          Commande: res.data.slice(-5),
        }));
      })
      .catch((msg) =>
        setstateCommande((prev) => ({
          ...prev,
          messageErrosCommande: msg.messageErrosCommande,
        }))
      );
  }, []);

  // Fetch Clients
  useEffect(() => {
    AfficheClientMagasinInAdmin(id)
      .GetClient()
      .then((res) => setstateClient((prev) => ({ ...prev, Client: res.data })))
      .catch((msg) => setstateClient((prev) => ({ ...prev, messageErrosClient: msg.messageErrosClient })));
  }, []);

  // Fetch Commercials
  useEffect(() => {
    AfficheCommercialMagasinInAdmin(id)
      .GetCommercial()
      .then((res) => setStateCommercial((prev) => ({ ...prev, commercial: res.data })))
      .catch((msg) => setStateCommercial((prev) => ({ ...prev, messageErrosCommercial: msg.messageErrosCommercial })));
  }, []);

  // Fetch Products
  useEffect(() => {
    setLoading(true);
    AfficheProductsService(id)
      .getProductByMagasin()
      .then((res) => setStateProduct(res.data))
      .catch((err) => setStateProduct({ stateProduct: [], messageErros: err.message || 'Erreur produit' }))
      .finally(() => setLoading(false));
  }, []);

  const [showPassword, setShowPassword] = useState(false);
  const [isBlocking, setIsBlocking] = useState(false);

  const { Info } = stateInfo;
  const { Commande, messageErrosCommande } = stateCommande;
  const { Client, messageErrosClient } = stateClient;
  const { commercial, messageErrosCommercial } = stateCommercial;

  const bloqué = async (e: any, id: any): Promise<any> => {
    e.preventDefault();
    setIsBlocking(true);
    const formData = new FormData();
    formData.append('id', id);
    try {
      await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/bloque-magasin`, formData).then(({ data }) => {
        window.location.reload();
      });
    } catch (error: AxiosError | any) {
      setIsBlocking(false);
    }
  };

  const handleGoBack = () => {
    window.history.back();
  };

  const getStatusBadge = (status: string) => {
    if (status === 'active') {
      return (
        <span className="status-badge status-active">
          <i className="bi bi-check-circle-fill"></i>
          Active
        </span>
      );
    } else {
      return (
        <span className="status-badge status-blocked">
          <i className="bi bi-x-circle-fill"></i>
          Bloqué
        </span>
      );
    }
  };

  const getOrderStatusClass = (status: string) => {
    switch (status) {
      case 'confirme':
        return 'order-status-confirmed';
      case 'annuler':
        return 'order-status-cancelled';
      default:
        return 'order-status-pending';
    }
  };

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner-container">
          <div className="spinner"></div>
          <span className="loading-text">Chargement des informations...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <NewSideBarAdmin />

      <div className="edit-magasin-container">
        {Info && Info.length > 0 ? (
          Info.map((inf) => (
            <div key={inf.id} className="edit-magasin-content">
              {/* Header Section */}
              <div className="page-header-a">
                <div className="header-top">
                  <button onClick={handleGoBack} className="back-button">
                    <i className="bi bi-arrow-left"></i>
                    Retour
                  </button>
                  {getStatusBadge(inf.status)}
                </div>

                <div className="header-main">
                  <div className="magasin-title-section">
                    <h1 className="magasin-name">{inf.NomMagasin}</h1>
                    <p className="magasin-location">
                      <i className="bi bi-geo-alt-fill"></i>
                      {inf.adresse_de_siege}
                    </p>
                  </div>

                  <div className="header-actions">
                    <button
                      onClick={(e) => bloqué(e, id)}
                      disabled={isBlocking}
                      className={`action-btn ${inf.status === 'active' ? 'btn-danger' : 'btn-success'}`}
                      style={isBlocking ? { opacity: 0.7, cursor: 'not-allowed' } : {}}
                    >
                      {isBlocking ? (
                        <>
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{marginRight: '8px'}}></span>
                          Traitement...
                        </>
                      ) : (
                        <>
                          <i className={`bi ${inf.status === 'active' ? 'bi-lock-fill' : 'bi-unlock-fill'}`}></i>
                          {inf.status === 'active' ? 'Bloquer le magasin' : 'Activer le magasin'}
                        </>
                      )}
                    </button>
                  </div>
                </div>

                {/* Stats Cards */}
                <div className="stats-grid">
                  <div className="stat-card">
                    <div className="stat-icon products">
                      <i className="bi bi-box-seam"></i>
                    </div>
                    <div className="stat-content">
                      <span className="stat-value">{stateProduct?.length || 0}</span>
                      <span className="stat-label">Produits</span>
                    </div>
                  </div>

                  <div className="stat-card">
                    <div className="stat-icon orders">
                      <i className="bi bi-cart-check"></i>
                    </div>
                    <div className="stat-content">
                      <span className="stat-value">{Commande?.length || 0}</span>
                      <span className="stat-label">Commandes</span>
                    </div>
                  </div>

                  <div className="stat-card">
                    <div className="stat-icon clients">
                      <i className="bi bi-people"></i>
                    </div>
                    <div className="stat-content">
                      <span className="stat-value">{Client?.length || 0}</span>
                      <span className="stat-label">Clients</span>
                    </div>
                  </div>

                  <div className="stat-card">
                    <div className="stat-icon staff">
                      <i className="bi bi-person-badge"></i>
                    </div>
                    <div className="stat-content">
                      <span className="stat-value">{commercial?.length || 0}</span>
                      <span className="stat-label">Commerciaux</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Tab Navigation */}
              <div className="tab-navigation">
                <button
                  className={`tab-button ${activeTab === 'info' ? 'active' : ''}`}
                  onClick={() => setActiveTab('info')}
                >
                  <i className="bi bi-info-circle"></i>
                  Informations
                </button>
                <button
                  className={`tab-button ${activeTab === 'orders' ? 'active' : ''}`}
                  onClick={() => setActiveTab('orders')}
                >
                  <i className="bi bi-receipt"></i>
                  Commandes
                </button>
                <button
                  className={`tab-button ${activeTab === 'staff' ? 'active' : ''}`}
                  onClick={() => setActiveTab('staff')}
                >
                  <i className="bi bi-people"></i>
                  Personnel
                </button>
              </div>

              {/* Tab Content */}
              <div className="tab-content">
                {/* Information Tab */}
                {activeTab === 'info' && (
                  <div className="info-section">
                    {Message && (
                      <div className="alert alert-success">
                        <i className="bi bi-check-circle"></i>
                        {Message}
                      </div>
                    )}

                    <form onSubmit={handleSubmitUpdate} className="info-form">
                      <div className="form-card">
                        <div className="form-card-header">
                          <h3>
                            <i className="bi bi-building"></i>
                            Informations du magasin
                          </h3>
                          <button
                            type="button"
                            className="edit-toggle-btn"
                            onClick={() => setIsEditing(!isEditing)}
                          >
                            <i className={`bi ${isEditing ? 'bi-x-lg' : 'bi-pencil'}`}></i>
                            {isEditing ? 'Annuler' : 'Modifier'}
                          </button>
                        </div>

                        <div className="form-grid">
                          <div className="form-group">
                            <label>Nom du magasin</label>
                            <input
                              type="text"
                              onChange={(e) => setMagasin(e.target.value)}
                              value={Magasin || inf.NomMagasin}
                              className="form-input"
                              disabled={!isEditing}
                              style={{ color: "black" }}
                            />
                          </div>

                          <div className="form-group">
                            <label>Nom du propriétaire</label>
                            <input
                              type="text"
                              onChange={(e) => setNom_prprietaires(e.target.value)}
                              value={Nom_prprietaire || inf.Nom_complet_propriétaire}
                              className="form-input"
                              disabled={!isEditing}
                              style={{ color: "black" }}

                            />
                          </div>

                          <div className="form-group">
                            <label>Email</label>
                            <input
                              type="email"
                              onChange={(e) => setemail(e.target.value)}
                              value={email || inf.email}
                              className="form-input"
                              disabled={!isEditing}
                              style={{ color: "black" }}

                            />
                          </div>

                          <div className="form-group">
                            <label>Mot de passe</label>
                            <div className="password-wrapper">
                              <input
                                type={showPassword ? 'text' : 'password'}
                                onChange={(e) => setpassword(e.target.value)}
                                value={password || inf.password}
                                className="form-input"
                                disabled={!isEditing}
                                style={{ color: "black" }}
                              />
                              <button
                                type="button"
                                className="password-toggle"
                                onClick={() => setShowPassword(!showPassword)}
                              >
                                <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                              </button>
                            </div>
                          </div>

                          <div className="form-group">
                            <label>Téléphone</label>
                            <input
                              type="tel"
                              onChange={(e) => settele(e.target.value)}
                              value={tele || inf.Tele}
                              className="form-input"
                              disabled={!isEditing}
                              style={{ color: "black" }}

                            />
                          </div>

                          <div className="form-group">
                            <label>Ville</label>
                            <input
                              type="text"
                              onChange={(e) => setadresse_de_siège(e.target.value)}
                              value={adresse_de_siege || inf.adresse_de_siege}
                              className="form-input"
                              disabled={!isEditing}
                              style={{ color: "black" }}

                            />
                          </div>

                          <div className="form-group full-width">
                            <label>Adresse complète</label>
                            <input
                              type="text"
                              onChange={(e) => setadresse_de_siège(e.target.value)}
                              defaultValue={adresse_de_siege || inf.adresse_de_siege}
                              className="form-input"
                              disabled={!isEditing}
                              style={{ color: "black" }}

                            />
                          </div>
                        </div>

                        {isEditing && (
                          <div className="form-actions">
                            <button type="submit" className="submit-btn">
                              <i className="bi bi-check-lg"></i>
                              Enregistrer les modifications
                            </button>
                          </div>
                        )}
                      </div>
                    </form>
                  </div>
                )}

                {/* Orders Tab */}
                {activeTab === 'orders' && (
                  <div className="orders-section">
                    <div className="section-header">
                      <h3>
                        <i className="bi bi-receipt"></i>
                        Historique des commandes
                      </h3>
                      <Link to="/historiques" className="view-all-link">
                        Voir tout
                        <i className="bi bi-arrow-right"></i>
                      </Link>
                    </div>

                    {Commande && Commande.length > 0 ? (
                      <div className="orders-table-wrapper">
                        <table className="orders-table">
                          <thead>
                            <tr>
                              <th>N° Commande</th>
                              <th>Date</th>
                              <th>Statut</th>
                              <th>Montant</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Commande.map((com) => (
                              <tr key={com.id}>
                                <td className="order-number">#{com.id}</td>
                                <td>{com.DateCommande}</td>
                                <td>
                                  <span className={`order-status ${getOrderStatusClass(com.Statut)}`}>
                                    {com.Statut}
                                  </span>
                                </td>
                                <td className="order-amount">{com.Montant} MAD</td>
                                <td>
                                  <button
                                    type="button"
                                    className="view-order-btn"
                                    onClick={() => setSelectedCommande(com)}
                                    aria-label={`Voir le détail de la commande ${com.id}`}
                                  >
                                    <i className="bi bi-eye"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div className="empty-state">
                        <i className="bi bi-receipt"></i>
                        <p>{messageErrosCommande}</p>
                      </div>
                    )}
                  </div>
                )}

                {/* Staff Tab */}
                {activeTab === 'staff' && (
                  <div className="staff-section">
                    {/* Commercials */}
                    <div className="staff-subsection">
                      <div className="section-header">
                        <h3>
                          <i className="bi bi-person-badge"></i>
                          Commerciaux ({commercial?.length || 0})
                        </h3>
                      </div>

                      {commercial && commercial.length > 0 ? (
                        <div className="staff-grid">
                          {commercial.map((com) => (
                            <div key={com.id} className="staff-card">
                              <div className="staff-avatar">
                                <img src={profil} alt={`${com.Nom} ${com.Prenom}`} />
                              </div>
                              <div className="staff-info">
                                <h4 className="staff-name">
                                  {com.Nom} {com.Prenom}
                                </h4>
                                <p className="staff-location">
                                  <i className="bi bi-geo-alt"></i>
                                  {com.Ville}
                                </p>
                                <div className="staff-details">
                                  <p>
                                    <i className="bi bi-envelope"></i>
                                    {com.Email}
                                  </p>
                                  <p>
                                    <i className="bi bi-telephone"></i>
                                    {com.Tele}
                                  </p>
                                </div>
                              </div>
                              <Link to={`/magasin/${inf.id}/commercial/${com.id}`} className="staff-view-btn">
                                Voir le profil
                                <i className="bi bi-arrow-right"></i>
                              </Link>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="empty-state small">
                          <i className="bi bi-person-badge"></i>
                          <p>{messageErrosCommercial}</p>
                        </div>
                      )}
                    </div>

                    {/* Clients */}
                    <div className="staff-subsection">
                      <div className="section-header">
                        <h3>
                          <i className="bi bi-people"></i>
                          Clients ({Client?.length || 0})
                        </h3>
                      </div>

                      {Client && Client.length > 0 ? (
                        <div className="staff-grid">
                          {Client.map((cl) => (
                            <div key={cl.id} className="staff-card">
                              <div className="staff-avatar">
                                <img src={profil} alt={`${cl.NomClient} ${cl.PrenomClient}`} />
                              </div>
                              <div className="staff-info">
                                <h4 className="staff-name">
                                  {cl.NomClient} {cl.PrenomClient}
                                </h4>
                                <p className="staff-location">
                                  <i className="bi bi-geo-alt"></i>
                                  {cl.Adresse}
                                </p>
                                <div className="staff-details">
                                  <p>
                                    <i className="bi bi-envelope"></i>
                                    {cl.Email}
                                  </p>
                                  <p>
                                    <i className="bi bi-telephone"></i>
                                    {cl.Tele}
                                  </p>
                                </div>
                              </div>
                              <Link to={`/magasin/${inf.id}/client/${cl.id}`} className="staff-view-btn">
                                Voir le profil
                                <i className="bi bi-arrow-right"></i>
                              </Link>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="empty-state small">
                          <i className="bi bi-people"></i>
                          <p>{messageErrosClient}</p>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="empty-state">
            <i className="bi bi-exclamation-triangle"></i>
            <p>Aucune information disponible</p>
          </div>
        )}
      </div>

      {/* Order Detail Popup */}
      {selectedCommande && (
        <OrderDetailModal
          commande={selectedCommande}
          statusClass={getOrderStatusClass(selectedCommande.Statut)}
          onClose={() => setSelectedCommande(null)}
        />
      )}
    </>
  );
};

// Order Detail Modal Component
const OrderDetailModal: React.FC<{
  commande: Commande;
  statusClass: string;
  onClose: () => void;
}> = ({ commande, statusClass, onClose }) => {
  // Close on Escape key
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div className="order-modal-overlay" onClick={onClose}>
      <div className="order-modal" onClick={(e) => e.stopPropagation()}>
        <div className="order-modal-header">
          <h3>
            <i className="bi bi-receipt"></i>
            Commande #{commande.id}
          </h3>
          <button className="order-modal-close" onClick={onClose} aria-label="Fermer">
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        <div className="order-modal-body">
          <div className="order-modal-row">
            <span className="order-modal-label">
              <i className="bi bi-hash"></i>
              N° Commande
            </span>
            <span className="order-modal-value">#{commande.id}</span>
          </div>

          <div className="order-modal-row">
            <span className="order-modal-label">
              <i className="bi bi-calendar-event"></i>
              Date
            </span>
            <span className="order-modal-value">{commande.DateCommande}</span>
          </div>

          <div className="order-modal-row">
            <span className="order-modal-label">
              <i className="bi bi-flag"></i>
              Statut
            </span>
            <span className={`order-status ${statusClass}`}>{commande.Statut}</span>
          </div>

          <div className="order-modal-row">
            <span className="order-modal-label">
              <i className="bi bi-cash-stack"></i>
              Montant
            </span>
            <span className="order-modal-value order-modal-amount">{commande.Montant} MAD</span>
          </div>
        </div>

        <div className="order-modal-footer">
          <Link to={`/historiques/${commande.id}`} className="submit-btn">
            <i className="bi bi-arrow-up-right"></i>
            Ouvrir la commande complète
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EditeMagasinUpgraded;